import get from 'lodash/get';
/**
 * @desc  PinCodeService class.
 * @ngInject
 */
export default class PinCodeService {
  /**
   * Constructor of the class.
   *
   * @param {$q} $q
   * @param {$log}  $log
   * @param {$http} $http
   */
  constructor(
    $q, $log, $http
  ) {
    this.$q = $q;
    this.$log = $log;
    this.$http = $http;
  }

  getPinCodes(studentUserId, params) {
    return this.$http({
      method: 'GET',
      url: `/SCR/PINCodes/students/${studentUserId}`,
      params
    }).then(result => {
      return this.$q.resolve(result.data);
    }, error => this.$q.reject(error));
  }

  hasValidPinCode(studentUserId, params) {
    return this.getPinCodes(studentUserId, params)
      .then(response => {
        if (response.length < 1) {
          return {
            isValid: false,
            reason: 'Wprowadzony kod PIN jest nieprawidłowy.'
          };
        }

        if (get(response[0], 'isUsed', true)) {
          return {
            isValid: false,
            reason: 'Podany kod PIN został już wykorzystany.'
          };
        }

        return {
          isValid: true,
          payload: response[0]
        };
      })
      .catch(({errorMessage = 'Wystąpił nieoczekiwany błąd.'}) => this.$q.reject({errorMessage}));
  }

  authorizeOutsidePersonByPin(data) {
    return this.$http({
      method: 'POST',
      url: '/SCR/authorizedOutsidePersons/PINCode',
      data
    }).then(result => {
      return {
        ...data,
        ...result.data
      };
    }, error => this.$q.reject({
      MessagePL: 'Nie udało się dodać osoby upoważnionej',
      Errors: [
        `Status: ${error.Status}`,
        `Code: ${error.Code}`
      ]
    }));
  }

  getAuthorizedOutsidePerson(studentUserId, params) {
    return this.$http({
      method: 'GET',
      url: `/SCR/authorizedOutsidePersons/students/${studentUserId}`,
      params
    }).then(result => {
      return this.$q.resolve(result.data);
    }, error => this.$q.reject(error));
  }

  addAuthorizedOutsidePerson(data) {
    return this.$http({
      method: 'POST',
      url: '/SCR/authorizedOutsidePersons',
      data
    }).then(result => {
      return {
        ...data,
        ...result.data
      };
    }, error => this.$q.reject(error));
  }

  editAuthorizedOutsidePerson(data) {
    return this.$http({
      method: 'PUT',
      url: `/SCR/authorizedOutsidePersons/${data.outsidePersonId}/manager`,
      data
    }).catch(error => {
      return this.$q.reject(error);
    });
  }

  removeAuthorizedOutsidePerson(id) {
    return this.$http({
      method: 'DELETE',
      url: `/SCR/authorizedOutsidePersons/${id}`
    }).catch(error => {
      this.$q.reject({
        MessagePL: 'Nie udało się usunąć osoby upoważnionej',
        Errors: [
          `Status: ${error.Status}`,
          `Code: ${error.Code}`
        ]
      });
    });
  }
}
